import { render, staticRenderFns } from "./DeliveryDeclarationDeleteModal.vue?vue&type=template&id=a16b5c82&scoped=true"
import script from "./DeliveryDeclarationDeleteModal.vue?vue&type=script&lang=js"
export * from "./DeliveryDeclarationDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16b5c82",
  null
  
)

export default component.exports